import React from 'react';
import _get from 'lodash/get';
import VisibilitySensor from 'react-visibility-sensor';
import { Tooltip, makeStyles } from '@material-ui/core';
import { SeriesResourceWithProgress } from 'containers/Series/components/main/SeriesResourceWithProgress';
import { SeriesHeartButton } from 'containers/Series/components/main/SeriesHeartButton';
import {
  COURSE_HEART_ICON_SEEN_LS_KEY,
  COURSE_SAVED_SERIES_RESOURCE_KEY,
} from 'containers/Course/constants';

const useStyles = makeStyles(theme => ({
  tooltip: {
    marginLeft: theme.spacing(1),
    ...theme.typography.pxSmall,

    '&.MuiTooltip-tooltipPlacementBottom': {
      marginLeft: 0,
      margin: '8px 0px',
    },
  },
}));

export const CourseSeriesProgress = ({
  activeSeries,
  coursesSiteCopy,
  seriesSiteCopy,
  navbarPageSiteCopy,
  completedResourcesIds,
  isAuthenticated,
  isDesktop,
  isTablet,
  isBigTablet,
  isMobile,
  activeResource,
  activeResourceIdx,
  handleCompleteChange,
  handleNext,
  completeResource,
  onProgressUpdate,
  onSeriesComplete,
  resourcesProgress,
  fontSize,
  resourceDescription,
  isSeriesComplete,
  completeSeriesAssessment,
  completedAssessments,
  saveResourceForLater,
  trackingProps,
  small,
}) => {
  const classes = useStyles();
  const tooltipLabel = _get(coursesSiteCopy, 'pageCopy.saveResourceTooltip');

  const renderHeartButton = ({ id, saved, handleSave }) => {
    const hasSeenHeart = !!localStorage.getItem(COURSE_HEART_ICON_SEEN_LS_KEY);
    const active = !saved && !hasSeenHeart;

    const onSave = e => {
      handleSave(e);
      saveResourceForLater({
        resourceId: id,
        isRemove: false,
        field: COURSE_SAVED_SERIES_RESOURCE_KEY,
      });
    };

    const onChange = isVisible => {
      if (isVisible) {
        setTimeout(() => {
          localStorage.setItem(COURSE_HEART_ICON_SEEN_LS_KEY, 'true');
        });
      }
    };

    return (
      <VisibilitySensor active={active} scrollCheck onChange={onChange}>
        <Tooltip
          title={tooltipLabel}
          placement={small ? 'bottom' : 'right'}
          classes={{ tooltip: classes.tooltip }}
          open={active || undefined}
        >
          <SeriesHeartButton
            saved={saved}
            handleSave={onSave}
            animated={active}
          />
        </Tooltip>
      </VisibilitySensor>
    );
  };

  return (
    <SeriesResourceWithProgress
      seriesSiteCopy={seriesSiteCopy}
      navbarPageSiteCopy={navbarPageSiteCopy}
      completedResourcesIds={completedResourcesIds}
      resources={_get(activeSeries, 'fields.resources')}
      isAuthenticated={isAuthenticated}
      item={activeSeries}
      isDesktop={isDesktop}
      isTablet={isTablet}
      isBigTablet={isBigTablet}
      isMobile={isMobile}
      activeResource={activeResource}
      activeResourceIdx={activeResourceIdx}
      handleCompleteChange={handleCompleteChange}
      handleNext={handleNext}
      completeResource={completeResource}
      onProgressUpdate={onProgressUpdate}
      onSeriesComplete={onSeriesComplete}
      resourcesProgress={resourcesProgress}
      resourceDescription={resourceDescription}
      fontSize={fontSize}
      isSeriesComplete={isSeriesComplete}
      completeSeriesAssessment={completeSeriesAssessment}
      completedAssessments={completedAssessments}
      trackingProps={trackingProps}
      renderHeartButton={renderHeartButton}
      showProgressTracking={false}
      isManualSeriesCompletion={false}
      linkAsPlainText
      showOpenInNewIcon={false}
      showShareAction={false}
      assessmentSpanFullWidth
    />
  );
};
